import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { trainTypeImages } from "../../trenitalia.service";

@Component({
    selector: 'trenitalia-train-breadcrumbs',
    templateUrl: './train-breadcrumbs.component.html',
    styleUrls: ['./train-breadcrumbs.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TrainBreadcrumbsComponent {
	@Input() trains: any[];

	get trainTypeImages(){
		return trainTypeImages;
	}
}